import Restriction from './Restriction';

export default Restriction;
